import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'
import type { AnyRoute } from '@tanstack/react-router'
import { i18n } from '../../shared/i18n/i18n'
import sv from './locales/sv.json'
import en from './locales/en.json'

i18n.addResourceBundle('sv', 'profile', sv, true, true)
i18n.addResourceBundle('en', 'profile', en, true, true)

export function buildProfileRoutes<TParent extends AnyRoute>(parent: TParent) {
  return [
    // Bare /profile → /profile/general redirect so the legacy bookmarks
    // continue working.
    createRoute({
      getParentRoute: () => parent,
      path: '/profile',
      beforeLoad: () => {
        throw redirect({ to: '/profile/general' })
      },
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/profile/general',
      component: lazyRouteComponent(
        () => import('./ProfileGeneralPage'),
        'ProfileGeneralPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/profile/reports',
      component: lazyRouteComponent(
        () => import('./ProfileReportsPage'),
        'ProfileReportsPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/profile/sms',
      component: lazyRouteComponent(
        () => import('./ProfileSmsPage'),
        'ProfileSmsPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/profile/email',
      component: lazyRouteComponent(
        () => import('./ProfileEmailPage'),
        'ProfileEmailPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/profile/emails',
      component: lazyRouteComponent(
        () => import('./ProfileEmailsPage'),
        'ProfileEmailsPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/profile/security',
      component: lazyRouteComponent(
        () => import('./ProfileSecurityPage'),
        'ProfileSecurityPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/profile/teams',
      component: lazyRouteComponent(
        () => import('./ProfileTeamsPage'),
        'ProfileTeamsPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/profile/areas',
      component: lazyRouteComponent(
        () => import('./ProfileAreasPage'),
        'ProfileAreasPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/profile/settings',
      component: lazyRouteComponent(
        () => import('./ProfileSettingsPage'),
        'ProfileSettingsPage',
      ),
    }),
  ]
}
